import Loading from 'components/Loading'

import { getPermission } from 'reduxpath/ducks/Impersonate'

const impersonate = (store, profileId, profileSlug) => {
  const adminEmail = store.getState().Auth.me.user.email
  store.dispatch(getPermission(profileId, adminEmail, profileSlug))
}

export default {
  populate: {
    impersonate,
  },
  components: {
    Loading,
  },
}
